function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4372 11.25C12.8935 11.25 8.12439 11.1975 8.12439 9.375C8.12439 7.5525 12.8935 7.5 13.4372 7.5C13.981 7.5 18.75 7.5525 18.75 9.375C18.75 11.1975 13.981 11.25 13.4372 11.25Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4372 12.1875C12.1013 12.1875 9.51376 12.0441 8.12439 11.0531V11.8753C8.12439 13.6978 12.8935 13.7503 13.4372 13.7503C13.981 13.7503 18.75 13.6978 18.75 11.8753V11.0531C17.3606 12.0441 14.7731 12.1875 13.4372 12.1875Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.081 14.4937C15.7931 14.8434 15.6244 15.3 15.6244 15.7809V16.1062C14.5997 16.2441 13.6622 16.2497 13.4372 16.2497C12.8935 16.2497 8.12439 16.2 8.12439 14.3747V13.5497C9.51189 14.5434 12.0994 14.6869 13.4372 14.6869C14.1066 14.6878 15.0938 14.6503 16.081 14.4937Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6253 17.056V17.1872H15.4688C14.7816 17.1872 14.1628 17.5932 13.8872 18.225C13.8122 18.3938 13.7747 18.5691 13.756 18.7435C13.606 18.75 13.5 18.75 13.4372 18.75C12.8935 18.75 8.12439 18.7003 8.12439 16.875V16.05C9.51189 17.0438 12.0994 17.1872 13.4372 17.1872C14.0063 17.1872 14.7938 17.1628 15.6253 17.056Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M15.2372 21.15C14.3681 21.2437 13.6369 21.2503 13.4372 21.2503C12.8935 21.2503 8.12439 21.2006 8.12439 19.3753V18.5503C9.51189 19.544 12.0994 19.6875 13.4372 19.6875C13.5872 19.6875 13.756 19.6875 13.9369 19.6809C14.0053 19.8244 14.1056 19.9622 14.2247 20.0869L15.2372 21.15Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M18.4378 22.5C18.3094 22.5 18.1866 22.4475 18.0975 22.3537L15.1285 19.2291C14.9991 19.0931 14.9635 18.8934 15.0375 18.7209C15.1116 18.5484 15.2803 18.4369 15.4678 18.4369H16.875V15.7809C16.875 15.3506 17.2257 15 17.656 15H19.2188C19.65 15 19.9997 15.3506 19.9997 15.7809V18.4369H21.406C21.5935 18.4369 21.7632 18.5484 21.8363 18.7209C21.9103 18.8934 21.8747 19.0931 21.7453 19.2291L18.7763 22.3537C18.6891 22.4475 18.5663 22.5 18.4378 22.5Z"
});

function SvgDataManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataManagement);
export default __webpack_public_path__ + "static/media/data-management.8dde40fc.svg";
export { ForwardRef as ReactComponent };